/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetShowcaseShiftsResponseAdmin } from '../models/GetShowcaseShiftsResponseAdmin';
import type { PutShowcaseShiftsRequestAdmin } from '../models/PutShowcaseShiftsRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShowcaseShiftsService {
    /**
     * **Required Policy:** `ViewShowcaseDetails`
     * @returns GetShowcaseShiftsResponseAdmin OK
     * @throws ApiError
     */
    public static getShowcaseShiftsAdmin({
        showcaseId,
    }: {
        showcaseId: number,
    }): CancelablePromise<GetShowcaseShiftsResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/showcaseshifts/{showcaseId}',
            path: {
                'showcaseId': showcaseId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShowcases`
     * @returns any OK
     * @throws ApiError
     */
    public static putShowcaseShiftsAdmin({
        showcaseId,
        requestBody,
    }: {
        showcaseId: number,
        requestBody?: PutShowcaseShiftsRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/showcaseshifts/{showcaseId}',
            path: {
                'showcaseId': showcaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
